module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "text-center center-block"
  }, [_vm._v("Liquidaciones a empresas proveedoras")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding-bottom": "1em"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-fill",
    attrs: {
      "to": "/liquidaciones/proveedores/form/null"
    }
  }, [_vm._v("Nueva liquidación")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-style line-top smart-form"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-head"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-1"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.numero),
      expression: "filtros.numero"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filtros.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtros.numero = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Empresa")]), _vm._v(" "), _c('combo-proveedores', {
    model: {
      value: (_vm.filtros.empresa),
      callback: function($$v) {
        _vm.filtros.empresa = $$v
      },
      expression: "filtros.empresa"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.estado),
      expression: "filtros.estado"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtros.estado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Generado"
    }
  }, [_vm._v("Generado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cerrado"
    }
  }, [_vm._v("Cerrado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Parcial"
    }
  }, [_vm._v("Pagado parcialmente")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pagado"
    }
  }, [_vm._v("Pagado totalmente")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Desde")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "default-date": _vm.filtros.desde
    },
    model: {
      value: (_vm.filtros.desde),
      callback: function($$v) {
        _vm.filtros.desde = $$v
      },
      expression: "filtros.desde"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Hasta")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "default-date": _vm.filtros.hasta
    },
    model: {
      value: (_vm.filtros.hasta),
      callback: function($$v) {
        _vm.filtros.hasta = $$v
      },
      expression: "filtros.hasta"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Empresa comensal")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.empresaCliente),
      expression: "filtros.empresaCliente"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtros.empresaCliente = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("Seleccione una empresa")]), _vm._v(" "), _vm._l((_vm.empresas), function(empresaCliente) {
    return _c('option', {
      key: empresaCliente._id,
      domProps: {
        "value": empresaCliente._id
      }
    }, [_vm._v(_vm._s(empresaCliente.empresa.razonSocial) + "-" + _vm._s(empresaCliente.denominacion))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer text-center"
  }, [_c('div', {
    staticClass: "form-group form-action"
  }, [_c('button', {
    staticClass: "btn btn-fill btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getLiquidaciones()
      }
    }
  }, [_vm._v("Aplicar")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-no-first-pad table-liquid"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.liquidacionesFiltradas), function(liquidacion) {
    return _c('tr', {
      key: liquidacion._id
    }, [_c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(liquidacion.numero))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatFecha")(liquidacion.fechaCreacion)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(liquidacion.proveedor.razonSocial))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(liquidacion.empresa))]), _vm._v(" "), _c('td', {
      staticClass: "derecha"
    }, [_vm._v(_vm._s(_vm._f("formatMoneda")(liquidacion.montoSinImpuestos)))]), _vm._v(" "), _c('td', {
      staticClass: "derecha"
    }, [_vm._v(_vm._s(liquidacion.comision) + "%")]), _vm._v(" "), _c('td', {
      staticClass: "derecha"
    }, [_vm._v(_vm._s(_vm._f("formatMoneda")(liquidacion.montoBrutoComision)))]), _vm._v(" "), _c('td', {
      class: _vm._f("lower")(liquidacion.estado)
    }, [_c('b', [_vm._v(_vm._s(liquidacion.estado))])]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "table-actions smart-form"
    }, [(liquidacion.estado === 'Generado') ? _c('li', [_c('a', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.clickCerrar(liquidacion)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-calculator"
    })])]) : _vm._e(), _vm._v(" "), (liquidacion.estado === 'Cerrado' || liquidacion.estado === 'Parcial' || liquidacion.estado === 'Pagado') ? _c('li', [_c('router-link', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "to": '/liquidaciones/proveedores/pago/' + liquidacion._id,
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-money"
    })])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "to": '/liquidaciones/proveedores/detalle/' + liquidacion._id,
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-eye"
    })])], 1)])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })]), _vm._v(" "), (_vm.liquidacionActiva) ? _c('div', {
    ref: "modalPago",
    staticClass: "modal",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "smart-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Monto")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-info"
  }, [_vm._v("El pago se imputará a la liquidación " + _vm._s(_vm.liquidacionActiva.numero))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Movimientos en la liquidación (" + _vm._s(_vm.liquidacionActiva.movimientos.length) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.liquidacionActiva.movimientos), function(movimiento) {
    return _c('tr', {
      key: movimiento._id
    }, [_c('td', [_vm._v(_vm._s(_vm._f("formatFecha")(movimiento.fecha)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(movimiento.tipo))]), _vm._v(" "), _c('td', [(!movimiento.esPago) ? _c('span', [_vm._v(_vm._s(_vm._f("formatMoneda")(movimiento.importe)))]) : _vm._e()]), _vm._v(" "), _c('td', [(movimiento.esPago) ? _c('span', [_vm._v(_vm._s(_vm._f("formatMoneda")(movimiento.importe)))]) : _vm._e()])])
  }))])]), _vm._v(" "), _vm._m(5)])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Número")]), _vm._v(" "), _c('th', [_vm._v("Fecha de creación")]), _vm._v(" "), _c('th', [_vm._v("Empresa")]), _vm._v(" "), _c('th', [_vm._v("Empresa Cliente")]), _vm._v(" "), _c('th', [_vm._v("Monto pedidos")]), _vm._v(" "), _c('th', [_vm._v("Porcentaje comisión")]), _vm._v(" "), _c('th', [_vm._v("Monto comisión")]), _vm._v(" "), _c('th', [_vm._v("Estado")]), _vm._v(" "), _c('th', [_vm._v("Acciones")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Crear pago")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Tipo de pago")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Comprobante")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Monto a pagar")]), _vm._v(" "), _c('th', [_vm._v("Monto pagado")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "text-center center-block"
  }, [_c('button', {
    staticClass: "btn btn-fill"
  }, [_vm._v("Guardar")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6268fa50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Liquidaciones/ListaProveedores.vue
// module id = 1136
// module chunks = 5